__turbopack_context__.v({
  "className": "noto_sans_gujarati_ab2cbeb7-module__F5pjia__className",
});
